export const GUIDANCE_DISMISSALS_STORAGE_KEY = 'fqhc-guidance-dismissed';

export const GUIDANCE_REQUIREMENT_KEYS = {
  CLIENTS: 'clients',
  TEMPLATES: 'templates',
};

export const getMissingFormRequirements = ({ hasClients, hasTemplates }) => {
  const missingRequirements = [];

  if (!hasClients) {
    missingRequirements.push(GUIDANCE_REQUIREMENT_KEYS.CLIENTS);
  }

  if (!hasTemplates) {
    missingRequirements.push(GUIDANCE_REQUIREMENT_KEYS.TEMPLATES);
  }

  return missingRequirements;
};

export const createGuidanceModel = (clients = [], templates = [], forms = []) => {
  const clientFormCounts = {};
  const templateFormCounts = {};

  forms.forEach((form) => {
    if (form.clientId) {
      clientFormCounts[form.clientId] = (clientFormCounts[form.clientId] || 0) + 1;
    }

    if (form.templateId) {
      templateFormCounts[form.templateId] = (templateFormCounts[form.templateId] || 0) + 1;
    }
  });

  const hasClients = clients.length > 0;
  const hasTemplates = templates.length > 0;
  const canCreateForms = hasClients && hasTemplates;
  const missingRequirements = getMissingFormRequirements({ hasClients, hasTemplates });

  return {
    hasClients,
    hasTemplates,
    canCreateForms,
    missingRequirements,
    clientFormCounts,
    templateFormCounts,
  };
};

export const createFormPrerequisiteItems = (guidanceModel) => [
  {
    id: GUIDANCE_REQUIREMENT_KEYS.CLIENTS,
    label: 'At least one client is available',
    complete: guidanceModel.hasClients,
    description: guidanceModel.hasClients
      ? 'Client records are ready to receive form instances.'
      : 'Add a client before starting a form.',
  },
  {
    id: GUIDANCE_REQUIREMENT_KEYS.TEMPLATES,
    label: 'At least one template is available',
    complete: guidanceModel.hasTemplates,
    description: guidanceModel.hasTemplates
      ? 'Templates are ready to define new form structure.'
      : 'Create a template before starting a form.',
  },
];

export const isHelpVisible = (dismissedHelp = {}, dismissKey, forceVisible = false) => {
  if (forceVisible || !dismissKey) {
    return true;
  }

  return !dismissedHelp[dismissKey];
};
